module.exports = __webpack_public_path__ + "static/media/my.789a6ddf.svg";